<script lang="ts" setup>
import {computed} from "vue";

import useStore from "@src/stores/store";

import FadeTransition from "@src/components/ui/transitions/FadeTransition.vue";
import Notifications from "@src/components/views/HomeView/Sidebar/Notifications/Notifications.vue";
import Settings from "@src/components/views/HomeView/Sidebar/Settings/Settings.vue";
import Holding from "@src/components/views/HomeView/Sidebar/Conversations/Holding.vue";
import Active from "@src/components/views/HomeView/Sidebar/Conversations/Active.vue";
import Bot from "@src/components/views/HomeView/Sidebar/Conversations/Bot.vue";
import Group from "@src/components/views/HomeView/Sidebar/Conversations/Group.vue";

const store = useStore();

// the selected sidebar component (e.g message/notifications/settings)
const ActiveComponent = computed((): any => {
    if (store.activeSidebarComponent === "active") {
        return Active;
    } else if (store.activeSidebarComponent === "holding") {
        return Holding;
    } else if (store.activeSidebarComponent === "group") {
        return Group;
    } else if (store.activeSidebarComponent === "bot") {
        return Bot;
    } else if (store.activeSidebarComponent === "notifications") {
        return Notifications;
    } else if (store.activeSidebarComponent === "settings") {
        return Settings;
    }
});
</script>

<template>
    <aside
        class="xs:w-full md:w-78.5 h-full md:p-0 flex flex-col overflow-visible transition-all duration-500"
    >
        <FadeTransition>
            <component :is="ActiveComponent" class="h-full flex flex-col"/>
        </FadeTransition>
    </aside>
</template>
